import type { MouseEvent } from 'react';

/** For buttons that close a form: pressing one leaves focus in the field, so its on-blur error doesn't flash up first. */
export const keepFocusOnPress = (event: MouseEvent) => event.preventDefault();
